module.exports = __webpack_public_path__ + "img/partner-facebook@2x.c0d29b04.png";